// extracted by mini-css-extract-plugin
export default {"inv_con":"Invoice_inv_con__aGmi1","text_boxes":"Invoice_text_boxes__x859a","invoiceTableHead":"Invoice_invoiceTableHead__2tLkV"};